module.exports = __webpack_public_path__ + "static/img/p-img1.473db7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/forum/p-img1.png
// module id = pqPd
// module chunks = 202